import { Component, Output, EventEmitter, Input, Injectable } from "@angular/core";
import { inject } from "@angular/core/testing";
import { identificationViewComponent } from "../../identification";

@Component({
    selector: 'zhuang-xiang-dan',
    templateUrl: './zhuangxiangdan.html',
    styleUrls: ['./zhuangxiangdan.css'],
    
})

export class zhuangxiangdanComponent {
    @Injectable() identificationViewComponent;
    @Output() drawTagEvent = new EventEmitter();
    // @Input() attrJson: object = {};
    parent:any;
    tabsName:object = {
        tab1Name:'装箱单',
        tab2Name:'源文件',
        tab3Name:'装箱单内容',
    }
    attrJson: any = {
        shipper: { value: '' }, // 发货人
        ourCompanyNo: { value: '' }, // 同行编号
        placeOfReceipt: { value: '' }, // 收货地
        consignee: { value: '' }, // 收货人
        notifyParty: { value: '' }, // 通知人
        portOfLoading: { value: '' }, // 起运港
        portOfDischarge: { value: '' }, // 卸货港
        portOfDestination: { value: '' }, // 目的港
        numberOfPieces: { value: '' }, // 件数
        grossWeight: { value: '' }, // 毛重
        volume: { value: '' }, // 体积
        packing: { value: '' }, // 包装
        etd: { value: '' }, // 要求ETD
        serviceTerm: { value: '' }, // 运输条款
        paymenTerm: { value: '' }, // 运费条款
        client: { value: '' }, // 委托方
        contacts: { value: '' }, // 联系人
        contactPhone: { value: '' }, // 联系人电话
        goodName: { value: '' }, // 品名
        marks: { value: '' }, // 唛头
        remarks: { value: '' }, // 备注
        /* -------------------------- */
        imgPath: '', // 图片
        originalPath: '' // 源文件
    };
    constructor(public ident:identificationViewComponent ) { 
        this.parent = ident
    }


    ngOnInit() {
        this.parent.setTabsName(this.tabsName)
        console.log(this.attrJson)
    }

    // input focus 标记 红色位置
    drawTag(rows) {
        this.parent.drawTag(rows) 
        this.drawTagEvent.emit(rows)
    }
}


// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/identificationView/component/zhuangxiangdan/zhuangxiangdan.ts